import type { UseCase } from '@/core/shared'
import type { AuthRepository } from '../domain'

export const doOauthSignIn: UseCase<AuthRepository, 'oauthSignIn'> = (repository) => {
  return async (signIn) => {
    return await repository.oauthSignIn(signIn)
  }
}
